import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { downloadCsvExport, exportFiltersFrom } from '../utils/downloadCsv';

/**
 * Shared CSV export button for list pages.
 * @param {() => Promise} exportRequest - API call returning blob response
 * @param {object} [filters] - current list filters (page/per_page stripped)
 * @param {string} [filename] - fallback download name
 * @param {string} [label]
 * @param {string} [className]
 */
const ExportCsvButton = ({
  exportRequest,
  filters = {},
  filename = 'export.csv',
  label = 'Export CSV',
  className = 'btn btn-secondary btn-sm',
}) => {
  const [exporting, setExporting] = useState(false);

  const handleExport = async () => {
    setExporting(true);
    try {
      const params = exportFiltersFrom(filters);
      await downloadCsvExport(() => exportRequest(params), filename);
      toast.success('Export downloaded');
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.message ||
        'Export failed';
      toast.error(typeof message === 'string' ? message : 'Export failed');
    } finally {
      setExporting(false);
    }
  };

  return (
    <button
      type="button"
      className={className}
      disabled={exporting}
      onClick={() => void handleExport()}
    >
      {exporting ? 'Exporting…' : label}
    </button>
  );
};

export default ExportCsvButton;
